"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = merge;

var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));

/**
 * Deep merges sources onto object. The same as [`lodash/merge`](https://lodash.com/docs/4.17.15#merge),
 * except arrays are not concatenated.  When a source object provides an array, it replaces the value on the target.
 * @param {*} object
 * @param {...any} sources
 */
function merge(object) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return _mergeWith["default"].apply(void 0, [object].concat(sources, [function (_objValue, srcValue) {
    if (Array.isArray(srcValue)) {
      return srcValue;
    }
  }]));
}
